import {
  fetchLocationViewTravel,
  type FetchLocationViewTravelOptions,
} from '../common/api/travelLocationView';
import type { AppDispatch } from '../stores';

export const FETCH_LOCATION_VIEW_TRAVEL = 'FETCH_LOCATION_VIEW_TRAVEL';
export const FETCH_LOCATION_VIEW_TRAVEL_SUCCESS = 'FETCH_LOCATION_VIEW_TRAVEL_SUCCESS';
export const FETCH_LOCATION_VIEW_TRAVEL_FAILURE = 'FETCH_LOCATION_VIEW_TRAVEL_FAILURE';

export const fetchTravelLocationView =
  (
    geonameId: string | string[] | undefined,
    cookies?: Record<string, unknown>,
    options?: FetchLocationViewTravelOptions,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({
      type: FETCH_LOCATION_VIEW_TRAVEL,
    });

    try {
      const response = await fetchLocationViewTravel(geonameId, cookies, options);
      const { taxonomy, url, associated, boundingBox, children, travelContent, breadCrumbs } =
        response ?? {};

      if (!travelContent && !breadCrumbs) {
        dispatch({
          type: FETCH_LOCATION_VIEW_TRAVEL_FAILURE,
          error: new Error('No travel content or location view data found'),
        });
        return;
      }

      await dispatch({
        type: FETCH_LOCATION_VIEW_TRAVEL_SUCCESS,
        url,
        taxonomy,
        associated,
        boundingBox,
        children,
        travelContent: travelContent ?? null,
        breadCrumbs,
      });
    } catch (err) {
      dispatch({
        type: FETCH_LOCATION_VIEW_TRAVEL_FAILURE,
        error: err,
      });
    }
  };
